import { useMediaQuery } from 'react-responsive';

import { useTheme } from '@desygner/ui-common-components';

export function useResponsive() {
  const theme = useTheme();

  return {
    isMobile: useMediaQuery({ maxWidth: theme.Screen.Size.Medium }),
    isTablet: useMediaQuery({
      minWidth: theme.Screen.Size.Medium,
      maxWidth: theme.Screen.Size.Large,
    }),
    isTabletOrMobile: useMediaQuery({
      minWidth: 0,
      maxWidth: theme.Screen.Size.Large,
    }),
    isDesktop: useMediaQuery({ minWidth: theme.Screen.Size.Large }),
  };
}
